export default __webpack_public_path__ + "static/report-2b9898f5c6a3013bf7bd3f6258511420.gif";